module.exports = __webpack_public_path__ + "assets/190454c5ff04b1efdb6dd404d0c3d8ec.jpg";